/* import __COLOCATED_TEMPLATE__ from './example.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();